import {ActionContext} from 'vuex';
import {AdminState, Admin} from '@/types/admin';
import {api} from '@/api';
import {GetMainMenus, ManagerInfo} from 'supporter';
import { RootState } from '@/store/root';

export default {
  namespaced: true,
  state: {
    admin: null,
    menuGroups: null,
    managerInfo: null,
    isCommerceAccount: false,
  },
  mutations: {
    SET_MENUS(state: AdminState, menus: GetMainMenus[]): void {
      state.menuGroups = menus;
    },
    SET_ADMIN(state: AdminState, admin: Admin): void {
      state.admin = admin;
    },
    SET_COMMERCE_ACCOUNT(state: AdminState, isCommerceAccount: boolean): void {
      state.isCommerceAccount = isCommerceAccount;
    },
    SET_MANAGER_INFO(state: AdminState, managerInfo: ManagerInfo): void {
      state.managerInfo = managerInfo;
    }
  },
  actions: {
    async fetchMainMenus({state, commit}: ActionContext<AdminState, any>, refreshFlg: boolean = false): Promise<any> {
      if (!refreshFlg) {
        if (state.menuGroups) {
          return;
        }
        const menuInfo = JSON.parse(localStorage.getItem('menuInfo') || null);
        if (menuInfo) {
          commit('SET_MENUS', menuInfo);
          return;
        }
      }
      const {data} = await api.getMainMenus();
      commit('SET_MENUS', data);
      window.localStorage.menuInfo = JSON.stringify(data);
    },
    async setAdmin({commit}: ActionContext<AdminState, any>, admin: Admin): Promise<any> {
      commit('SET_ADMIN', admin);
      localStorage.setItem('adminInfo', JSON.stringify(admin));
    },
    setCommerceAccount({ commit }: ActionContext<AdminState, RootState>, isCommerceAccount: boolean) {
      commit('SET_COMMERCE_ACCOUNT', isCommerceAccount);
    },
    async fetchMyManageInfo({state, commit}: ActionContext<AdminState, any>, refreshFlg: boolean = false): Promise<any> {
      if (!refreshFlg) {
        if (state.managerInfo) {
          return;
        }
        const managerInfo = JSON.parse(localStorage.getItem('managerInfo') || null);
        if (managerInfo) {
          commit('SET_MANAGER_INFO', managerInfo);
          return;
        }
      }

      const {data}: any = await api.getManagerInfo();
      commit('SET_MANAGER_INFO', data);
      window.localStorage.managerInfo = JSON.stringify(data);
    }
  },
  getters: {
    admin(state: AdminState): Admin | undefined {
      if (state.admin) {
        return state.admin;
      }
      if (localStorage.getItem('adminInfo')) {
        const admin = JSON.parse(localStorage.getItem('adminInfo'));
        return admin;
      }
    },
    isCommerceAccount(state: AdminState): boolean {
      return state.isCommerceAccount;
    },
    adminPlan(state: AdminState): string | undefined {
      if (state.managerInfo) {
        return state.managerInfo.seller.plan; // STANDARD, PREMIUM
      }
      const managerInfo = JSON.parse(localStorage.getItem('managerInfo') || null);
      if (managerInfo) {
        return managerInfo.seller.plan;
      }
    },
    adminPlanTitle(state: AdminState): string | undefined {
      if (state.managerInfo) {
        return state.managerInfo.seller.plan === 'PREMIUM' ? 'shop by premium' : 'NCP'; // STANDARD, PREMIUM
      }
      const managerInfo = JSON.parse(localStorage.getItem('managerInfo') || null);
      if (managerInfo) {
        return managerInfo.seller.plan === 'PREMIUM' ? 'shop by premium' : 'NCP'; // STANDARD, PREMIUM
      }
      return 'NCP';
    },
    menuGroups(state: AdminState): GetMainMenus[] | undefined {
      if (state.menuGroups) {
        return state.menuGroups;
      }
      if (localStorage.getItem('menuInfo')) {
        const admin = JSON.parse(localStorage.getItem('menuInfo'));
        return admin;
      }
    }
  }
};
